import type { CollectedDataItem } from '../../domain/message';
import UrlService from '../UrlService';

import SharedDataExtractionService from './sharedDataExtractionService';

const createGoogleSheetsDataExtractionService = () => {
  const { extractContentByKey, extractCompanyDomainFromEmail, isNotIgnoredDomain } = SharedDataExtractionService;

  const transformUrl = (inputUrl: string) => {
    if (!UrlService.isValidUrl(inputUrl)) {
      return;
    }

    const httpsUrl = inputUrl.startsWith('http') ? inputUrl : `https://${inputUrl}`;
    let url: URL;

    try {
      url = new URL(httpsUrl);
    } catch {
      return;
    }

    return UrlService.removeWWW(url.hostname);
  };

  const extractData = (collectedData: CollectedDataItem[]) => {
    const rawData = (extractContentByKey(collectedData, 'Cell data') ?? '') as string;
    const collectedValues = rawData
      .trim()
      .split(/\s|\s?[,|]\s?/)
      .filter(Boolean);

    const collectedDomains = new Set<string>();

    collectedValues.forEach((value) => {
      let domain: string;
      if (value.includes('@')) {
        domain = extractCompanyDomainFromEmail(value)?.toLowerCase() as string;
      } else {
        domain = transformUrl(value) ?? '';
      }

      if (isNotIgnoredDomain(domain) && UrlService.isValidUrl(domain)) {
        collectedDomains.add(domain);
      }
    });

    return { collectedDomains: Array.from(collectedDomains) };
  };

  return { extractData };
};

const GoogleSheetsDataExtractionService = createGoogleSheetsDataExtractionService();
export default GoogleSheetsDataExtractionService;
